/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurlyLoop = createReactComponent("outline", "curly-loop", "IconCurlyLoop", [["path", { "d": "M21 8c-4 0 -7 2 -7 5a3 3 0 0 0 6 0c0 -3 -2.5 -5 -8 -5s-8 2 -8 5a3 3 0 0 0 6 0c0 -3 -3 -5 -7 -5", "key": "svg-0" }]]);

export { IconCurlyLoop as default };
//# sourceMappingURL=IconCurlyLoop.mjs.map
